<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title fw-bold">{{ 'study-editor.advance-sample.modal.title' | translate }}</h4>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
    </div>
    <jhi-advance-samples
    [studyId]="studyId"
    [replicationNumber]="replicationNumber"
    [selectedInstances]="selectedInstances">
    </jhi-advance-samples>
</div>
